import { RemoteSettingsAPI } from "../api/remoteSettingsApi";
import type { FeatureFlags, ISettingsAPI, MaintenanceStatus, Settings } from "../api/settingsApi";

/**
 * Service for managing system settings
 */
export class SettingsService {
  public api: ISettingsAPI;

  constructor(api?: ISettingsAPI) {
    this.api = api || new RemoteSettingsAPI();
  }

  /**
   * Get system settings
   */
  async getSettings(): Promise<Settings> {
    return await this.api.getSettings();
  }

  /**
   * Update system settings
   */
  async updateSettings(updates: Partial<Omit<Settings, "id">>): Promise<Settings> {
    return await this.api.updateSettings(updates);
  }

  /**
   * Get maintenance mode status (authenticated)
   */
  async getMaintenanceStatus(): Promise<MaintenanceStatus> {
    return await this.api.getMaintenanceStatus();
  }

  /**
   * Get maintenance mode status (public - no auth required)
   */
  async getPublicMaintenanceStatus(): Promise<MaintenanceStatus> {
    return await this.api.getPublicMaintenanceStatus();
  }

  /**
   * Get runtime feature flags (authenticated; readable by any role).
   */
  async getFeatureFlags(): Promise<FeatureFlags> {
    return await this.api.getFeatureFlags();
  }
}
